// client\src\components\registroAnalise.jsx

import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationManager } from 'react-notifications';
import CreateCliente from '../components/Usuarios/CreateCliente';
import { parseISO, format, isValid } from 'date-fns';

const STATUS_LABEL = { 0: 'Pendente', 1: 'Em andamento', 2: 'Concluído' };

function RegistroAnalise({ initialDate, editData, onSuccess, onCancel, onComprovante }) {
    const [tipo, setTipo] = useState('analise de perfil');
    const [tiposList, setTiposList] = useState([]);
    const [vendedor, setVendedor] = useState('');
    const [produtor, setProdutor] = useState('');
    const [clientId, setClientId] = useState('');
    const [dataDia, setDataDia] = useState('');        // "YYYY-MM-DD"
    const [dataHorario, setDataHorario] = useState(''); // "HH:mm"
    // const [meetLink, setMeetLink] = useState('');


    const [observacoes, setObservacoes] = useState('');
    const [statusAnalise, setStatusAnalise] = useState(0);

    const [clientesList, setClientesList] = useState([]);
    const [showAllClientes, setShowAllClientes] = useState(false);
    const [parceirosList, setParceirosList] = useState([]);
    const [vendedoresList, setVendedoresList] = useState([]);
    const [produtoresList, setProdutoresList] = useState([]);

    // erros
    const [clienteError, setClienteError] = useState(false);
    const [vendedorError, setVendedorError] = useState(false);
    const [produtorError, setProdutorError] = useState(false);
    const [dataError, setDataError] = useState(false);

    // ---------- ESTADOS DO COMPROVANTE ----------
    const [showComprovante, setShowComprovante] = useState(false);
    const [comprovante, setComprovante] = useState(null);

    // helpers p/ nomes e datas
    const getUserByCpf = (cpf) => {
        const norm = String(cpf || '').replace(/\D/g, '');
        return [...vendedoresList, ...produtoresList].find(u => String(u.cpf || '').replace(/\D/g, '') === norm);
    };
    const getClienteById = (id) => clientesList.find(c => String(c.id) === String(id));



const fmtData = (dia, hhmm) => {
    if (!dia) return '';
    const [h = '00', m = '00'] = String(hhmm || '00:00').split(':');
    let dateObj;

    try {
        dateObj = parseISO(dia);
        if (!isValid(dateObj)) throw new Error('Data inválida');
        dateObj.setHours(Number(h));
        dateObj.setMinutes(Number(m));
        return format(dateObj, "dd/MM/yyyy 'às' HH:mm");
    } catch (e) {
        console.warn('Erro ao formatar data:', e);
        return `${dia.split('T')[0]} ${hhmm || ''}`;
    }
};


    const agoraFmt = () => format(new Date(), "dd/MM/yyyy HH:mm");

    // prefill: criação (dia/hora) ou edição (todos os campos)
    useEffect(() => {
        if (editData?.id) {
            setVendedor(editData.vendedor || '');
            setProdutor(editData.produtor || '');
            setClientId(editData.client_id || '');
            // setMeetLink(editData.meet_link || '');



            // Preferir dataDia/dataHorario vindos do back
            if (editData.dataDia) {
                setDataDia(editData.dataDia);
                setDataHorario((editData.dataHorario || '').slice(0, 5));
            } else if (editData.data) {
                // compat: extrai de "YYYY-MM-DDTHH:mm"
                const s = String(editData.data).replace('T', ' ');
                const m = s.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
                if (m) { setDataDia(m[1]); setDataHorario(m[2]); }
            } else if (initialDate) {
                if (typeof initialDate === 'object' && initialDate.dataDia) {
                    setDataDia(initialDate.dataDia);
                    setDataHorario((initialDate.dataHorario || '').slice(0, 5));
                }
            }


            let obs = editData.observacoes;
            try {
                const p = typeof obs === 'string' ? JSON.parse(obs) : obs;
                obs = typeof p === 'string' ? p : (p ? JSON.stringify(p) : '');
            } catch { /* mantém como está */ }
            setObservacoes(obs || '');
            setStatusAnalise(Number(editData.statusAnalise) || 0);
            setTipo(editData.tipo || 'analise de perfil');



        } else if (initialDate) {
            if (typeof initialDate === 'object' && initialDate.dataDia) {
                setDataDia(initialDate.dataDia);
                setDataHorario((initialDate.dataHorario || '').slice(0, 5));
            }
        }
    }, [editData, initialDate]);

    useEffect(() => {
        (async () => {
            try {
                const resCliente = await api.get('/clientesAgiliza');
                setClientesList(resCliente.data);
                const resParceiro = await api.get('/clientesParceiros');
                setParceirosList(resParceiro.data);
                const resVP = await api.get('/vendedores-produtores');
                if (resVP.data && Array.isArray(resVP.data.data)) {
                    const users = resVP.data.data;
                    setVendedoresList(users.filter(u => u.is_vendedor === 1));
                    setProdutoresList(users.filter(u => u.is_produtor === 1));
                } else {
                    NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
                }


                // TIPOS (mesma ideia de vendedores/produtores)
                try {
                    const resTipos = await api.get('/tipos-analise');
                    const arr = resTipos?.data?.data || [];
                    setTiposList(arr);
                    // se vier vazio, fallback local:
                    if (!arr.length) {
                        setTiposList([
                            { id: 1, nome: 'Análise de perfil', chave: 'analise de perfil' },
                            { id: 2, nome: 'Treinamento', chave: 'treinamento' },
                            { id: 3, nome: 'Re-análise', chave: 're-analise' },
                            { id: 4, nome: 'Reversão de negativa', chave: 'reversao de negativa' },
                        ]);
                    }
                } catch (e) {
                    // fallback se a rota ainda não existir
                    setTiposList([
                        { id: 1, nome: 'Análise de perfil', chave: 'analise de perfil' },
                        { id: 2, nome: 'Treinamento', chave: 'treinamento' },
                        { id: 3, nome: 'Re-análise', chave: 're-analise' },
                        { id: 4, nome: 'Reversão de negativa', chave: 'reversao de negativa' },
                    ]);
                }




            } catch (err) {
                console.error(err);
                NotificationManager.error('Erro ao carregar dados.', 'Erro');
            }
        })();
    }, []);

    const handleClienteSelecionado = (id) => {
        setClientId(id);
        if (id) setClienteError(false);
    };

    const validarCampos = () => {
        let ok = true;

        if (!clientId) { setClienteError(true); ok = false; } else setClienteError(false);
        if (!vendedor) { setVendedorError(true); ok = false; } else setVendedorError(false);
        if (!produtor) { setProdutorError(true); ok = false; } else setProdutorError(false);
        // if (!meetLink) { /* opcional */ }
        if (!dataDia || !dataHorario) { setDataError(true); ok = false; } else setDataError(false);
        if (!String(tipo || '').trim()) ok = false;
        if (!ok) NotificationManager.warning('Preencha os campos obrigatórios.', 'Campos obrigatórios', 3000);
        return ok;
    };
    // --------- MONTA E EXIBE O COMPROVANTE ---------
    const montarComprovante = () => {
        const cli = getClienteById(clientId) || {};
        const vend = getUserByCpf(vendedor) || {};
        const prod = getUserByCpf(produtor) || {};
        

        let obs = observacoes;
        try {
            const parsed = typeof obs === 'string' ? JSON.parse(obs) : obs;
            obs = typeof parsed === 'string' ? parsed : (parsed ? JSON.stringify(parsed, null, 2) : '');
        } catch { /* deixa como string */ }

        console.log("meetLink no comprovante:", cli.meetLink);
        console.log(cli);


        const comp = { // retorna objeto pronto
            clienteId: clientId,
            clienteNome: cli.Nome || cli.nome || '',
            clienteContato: cli.contato || '',
            vendedorCpf: vendedor,
            vendedorNome: vend?.nome || '',
            produtorCpf: produtor,
            produtorNome: prod?.nome || '',
            dataDia,
            dataHorario,
            dataFmt: fmtData(dataDia, dataHorario),
            status: Number(statusAnalise) || 0,
            statusLabel: STATUS_LABEL[Number(statusAnalise) || 0],
            observacoes: obs || '',
            geradoEm: agoraFmt(),
            tipo: tipo,
            meetLink: cli.meetLink || 'sem link da chamada' // inclui o meetLink aqui
        };

        setComprovante(comp);
        setShowComprovante(true);
        return comp; // NEW
    };

    // --------- CÓPIA DO COMPROVANTE ---------

    const copyComprovante = async () => {
        try {
            const el = document.getElementById('copiarAnalise');
            const text = el ? el.innerText : '';
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                const r = document.createRange();
                r.selectNode(el);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(r);
                document.execCommand('copy');
                sel.removeAllRanges();
            }
            NotificationManager.success('Comprovante copiado!', 'Sucesso');
        } catch {
            NotificationManager.error('Não foi possível copiar o comprovante.', 'Erro');
        }
    };

    const handleSubmit = async () => {
        if (!validarCampos()) return;

        const payloadBase = {
            vendedor,
            produtor,
            client_id: clientId,
            dataDia,
            dataHorario: dataHorario ? `${dataHorario}:00` : '00:00:00',
            observacoes: observacoes ? JSON.stringify(observacoes) : '{}',
            statusAnalise,
            tipo
        };

        try {
            if (editData?.id) {
                const response = await api.post('/updateAgendamentoAnalise', { id: editData.id, ...payloadBase });
                if (response.data?.status) {
                    NotificationManager.success('Agendamento atualizado com sucesso!', 'Sucesso');
                    const comp = montarComprovante();             // NEW
                    onComprovante?.(comp);                        // NEW: entrega ao pai
                    onSuccess?.();                                // fecha no pai
                } else {
                    NotificationManager.error('Erro ao atualizar o agendamento', 'Erro');
                }
            } else {
                const response = await api.post('/createAgendamentoAnalise', payloadBase);
                if (response.data?.status) {
                    NotificationManager.success('Agendamento criado com sucesso!', 'Sucesso');
                    console.log("response.data")
                    console.log(response.data)
                    // setMeetLink(response.data.meetLink || ''); // atualiza o meetLink se vier do back
                    const comp = montarComprovante();
                    comp.meetLink = response.data.meetLink || 'sem link da chamada'; // adiciona meetLink ao comprovante
                    onComprovante?.(comp);
                    // limpar
                    setVendedor(''); setProdutor(''); setClientId(''); setDataDia(''); setDataHorario('');
                    setObservacoes(''); setStatusAnalise(0);
                    onSuccess?.();                                // fecha no pai
                } else {
                    NotificationManager.error('Erro ao criar o agendamento', 'Erro');
                }
            }
        } catch (error) {
            console.error(error);
            NotificationManager.error('Falha na operação.', 'Erro');
        }
    };

    return (
        <div className={styles.app}>
            <div className={styles.cadastroClienteContainerAnalise}>
                <CreateCliente
                    clientesList={clientesList}
                    handleToggleShowAll={() => setShowAllClientes(!showAllClientes)}
                    showAllClientes={showAllClientes}
                    parceirosList={parceirosList}
                    onClienteSelecionado={handleClienteSelecionado}
                    errorCliente={clienteError}
                    selectedId={clientId}
                />

                <p className={styles.inputText} style={{ margin: 10 }}>--------------- RESPONSÁVEIS ---------------</p>
                <div className={styles.rowTwoCols}>
                    <div className={styles.containerVendedor}>
                        <select
                            onChange={(e) => { setVendedor(e.target.value); setVendedorError(false); }}
                            value={vendedor}
                            className={`${styles.inputFilter} ${styles.fullWidth} ${vendedorError ? styles.errorBorder : ''}`}
                        >
                            <option value="">Vendedor</option>
                            {vendedoresList.map(v => <option key={v.id} value={v.cpf}>{v.nome}</option>)}
                        </select>
                    </div>
                    <div className={styles.containerVendedor}>
                        <select
                            onChange={(e) => { setProdutor(e.target.value); setProdutorError(false); }}
                            value={produtor}
                            className={`${styles.inputFilter} ${styles.fullWidth} ${produtorError ? styles.errorBorder : ''}`}
                        >
                            <option value="">Produtor</option>
                            {produtoresList.map(p => <option key={p.id} value={p.cpf}>{p.nome}</option>)}
                        </select>
                    </div>

                    <div className={styles.containerVendedor}>
                        {/* <p className={styles.inputText}>Tipo</p> */}
                        <select
                            className={styles.inputFilter}
                            // style={{ width: "260px" }}
                            value={tipo}
                            onChange={(e) => setTipo(e.target.value)}
                        >
                            <option value="">Selecione o tipo</option>
                            {tiposList.map(t => (
                                <option key={t.id} value={t.chave}>{t.nome}</option>
                            ))}
                        </select>
                    </div>

                </div>

                <p className={styles.inputText} style={{ margin: 10 }}>--------------- AGENDAMENTO ---------------</p>

                <div className={styles.rowTwoCols} style={{ gap: 8 }}>
                    <div className={styles.containerTituloInput} style={{ display: "contents" }}>
                        <input
                            type="date"
                            onChange={(e) => { setDataDia(e.target.value); setDataError(false); }}
                            value={dataDia ? dataDia.split('T')[0] : ''} // garante só a data
                            className={`${styles.inputFilter} ${dataError && !dataDia ? styles.errorBorder : ''}`}
                        />
                    </div>
                    <div className={styles.containerTituloInput} style={{ display: "contents" }}>
                        <input
                            type="time"
                            step="60"
                            onChange={(e) => { setDataHorario(e.target.value); setDataError(false); }}
                            value={dataHorario}
                            className={`${styles.inputFilter} ${dataError && !dataHorario ? styles.errorBorder : ''}`}
                        />
                    </div>
                </div>

                <p className={styles.inputText} style={{ margin: 10 }}>--------------- OBSERVAÇÕES ---------------</p>
                <div className={styles.containerTituloInput}>
                    <textarea
                        onChange={(e) => setObservacoes(e.target.value)}
                        value={observacoes}
                        className={styles.textArea}
                        placeholder="Digite observações (opcional)"
                    />
                </div>

                <div className={styles.containerTituloInput}>
                    <p className={styles.inputText}>Status da Análise</p>
                    <select
                        onChange={(e) => setStatusAnalise(e.target.value)}
                        value={statusAnalise}
                        className={styles.inputFilter}
                        style={{ width: "160px" }}
                    >
                        <option value={0}>Pendente</option>
                        <option value={1}>Em andamento</option>
                        <option value={2}>Concluído</option>
                    </select>
                </div>

                <div className={styles.buttonContainer} style={{ display: 'flex', gap: 8 }}>
                    <button onClick={handleSubmit} className={styles.cadastroCliente}>
                        {editData?.id ? 'Atualizar' : 'Registrar'}
                    </button>
                    {onCancel && (
                        <button onClick={onCancel} className={styles.cancelButton}>
                            Cancelar
                        </button>
                    )}
                </div>

                {/* --------- BLOCO DO COMPROVANTE --------- */}
                {showComprovante && comprovante && (
                    <div
                        className={`${styles.cadastroClienteContainer} ${styles.copiar}`}
                        onClick={copyComprovante}
                        title="Clique para copiar"
                    >
                        <div className={styles.copiarTop}>
                            COMPROVANTE DA ANÁLISE (clique para copiar)
                        </div>
                        <p id="copiarAnalise" className={styles.copiarText}>
                            Tipo: {comprovante.tipo}<br />
                            Cliente: {comprovante.clienteNome} {comprovante.clienteId ? `(ID ${comprovante.clienteId})` : ''}<br />
                            {comprovante.clienteContato && <>Contato: {comprovante.clienteContato}<br /></>}
                            Data/Hora: {comprovante.dataFmt}<br />
                            Vendedor: {comprovante.vendedorNome || comprovante.vendedorCpf}<br />
                            Produtor: {comprovante.produtorNome || comprovante.produtorCpf}<br />
                            Status: {comprovante.statusLabel}<br />
                            <br />
                            Observações:<br />
                            {comprovante.observacoes || '—'}<br />
                            <br />
                            Gerado em: {comprovante.geradoEm}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default RegistroAnalise;
